import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Feedback from "./ViewJob/Feedback.jsx";
// import { FeedbackSuccessAction } from "../../../Redux/action/FeedbackDataAction.js";
import { Button, Modal } from "react-bootstrap";
import {
  useCandidateById,
  useVendorById,
} from "../../../Hooks/useUserDetails.js";
import {
  getInterviewById,
  InterviewComplete,
} from "../../../Services/interviewService.js";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction.js";
import { VendorProfile } from "../../../Redux/action/VendorProfileAction.js";
import Loader from "../../Common/Loader/loader.js";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { Close, DescriptionOutlined } from "@mui/icons-material";

const AssignedInterviewsInfo = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const [openResume, setOpenResume] = React.useState(false);
  const userIdData = userResult?.userid;
  const candidateIdData = localStorage.getItem("candidateVendorId");
  const userInfo = useSelector((state) => state.Profile.result);
  // const vendorIdData = userInfo?.vendorId;
  const location = useLocation();
  const { interviewId } = useParams();
  const interviewIDFromURL = interviewId;
  const [receivedData, setReceivedData] = useState(null);
  const [reload, setReload] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [isInterviewComplete, setIsComplete] = useState(false);
  const [isComeDis, setIsComeDis] = useState(false);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { data: interviewerVendor, isLoading: isLoadingVendor } = useVendorById(
    receivedData?.interviewerVendorId
  );
  const { data: candidateVendor, isLoading: isLoadingVendorCandidate } =
    useVendorById(
      receivedData?.candidateVendorId,
      !!receivedData?.candidateVendorId
    );
  const { data: candidateDetails, isLoading: isLoadingCandidate } =
    useCandidateById(
      receivedData?.candidateId,
      !receivedData?.candidateVendorId
    );
  useEffect(() => {
    setIsLoading(true);
    getInterviewById(interviewIDFromURL).then((res) => {
      setReceivedData(res);
      setIsLoading(false);
    });
  }, [interviewIDFromURL]);

  useEffect(() => {
    if (candidateIdData) {
      dispatch(CandidateProfile(userIdData));
      dispatch(VendorProfile(candidateIdData));
    }
  }, [candidateIdData]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isJoinButtonEnabled = () => {
    const interviewDateStr = receivedData?.interviewDate;
    if (!interviewDateStr) return false;
    const interviewDate = new Date(interviewDateStr?.replace(" ", "T"));

    const joinTime = new Date(interviewDate.getTime() - 10 * 60 * 1000); // 10 minutes before interview
    return new Date() >= joinTime;
  };

  const handleOpenResume = () => setOpenResume(true);
  const handleCloseResume = () => setOpenResume(false);

  const isFeedbackButtonEnabled = () => {
    const interviewDateStr = receivedData?.interviewDate;
    if (!receivedData?.interviewDate) return false;
    const interviewDate = new Date(interviewDateStr?.replace(" ", "T"));
    const feedTime = new Date(interviewDate.getTime() + 5 * 60 * 1000); // 5 minutes after interview
    return new Date() >= feedTime;
  };

  const handleCompleteInterview = () => {
    setIsComeDis(true);
    const data = {
      interviewId: parseInt(receivedData?.interviewId),
      isInterviewClosed: true,
    };
    InterviewComplete(data).then((res) => {
      setIsComplete(false);
      setIsComeDis(false);
      // setReload(true)
      setIsLoading(true);
      getInterviewById(interviewIDFromURL).then((res) => {
        setReceivedData(res);
        setIsLoading(false);
      });
    });
  };

  if (
    isLoadingVendor ||
    isLoadingVendorCandidate ||
    isLoadingCandidate ||
    isLoading
  )
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader />
      </div>
    );

  return (
    <>
      <div
        style={
          location.pathname.includes("/admin/interview/interviews_info")
            ? { backgroundColor: "rgb(246, 249, 255)", minHeight: "100vh" }
            : {}
        }
        className={
          location.pathname.includes("admin") ? "mt-1" : "common_wrapper"
        }
      >
        <div
          className="vj_container d-flex justify-content-between "
          style={
            location.pathname.includes("/admin/interview/interviews_info")
              ? { padding: "10px", width: "98%", margin: "0px auto" }
              : { margin: "35px 0px" }
          }
        >
          <div
            // className="vj_left "
            style={{
              minWidth: location.pathname.includes(
                "/admin/interview/interviews_info"
              )
                ? "100%"
                : "100%",
              padding: "5px",
              backgroundColor: "white",
              boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="common_table_header">
              <p style={{ margin: "0px" }}>Interview Details</p>
            </div>
            <div className="line_divide"></div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  window.innerWidth < 600 ? "1fr" : "repeat(2, 1fr)",
                gap: "16px",
                padding: "12px",
                marginTop: "16px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography fontWeight={600}>Candidate Name:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.candidateName || "N/A"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography fontWeight={600}>Job Position:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.jobPosition || "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}
              >
                <Typography fontWeight={600}>Interview Mode:</Typography>
                <Chip
                  label={receivedData?.interviewMode || "N/A"}
                  size="small"
                  sx={{
                    backgroundColor: "#EEF5FF",
                    color: "#286A94",
                    fontWeight: 600,
                    borderRadius: "8px",
                  }}
                />
              </Box>

              <Typography sx={{ mt: 2 }}>
                <strong>Round:</strong>{" "}
                <span
                  style={{
                    background: "#EEF5FF",
                    padding: "2px 8px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    color: "#286A94",
                  }}
                >
                  {receivedData?.round}
                </span>
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}
              >
                <Typography fontWeight={600}>Interviewer Name:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.interviewerName || "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}
              >
                <Typography fontWeight={600}>Duration:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.duration || "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}
              >
                <Typography fontWeight={600}>Interview Date:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.interviewDate.split(" ")[0].split("-")[2] +
                    "-" +
                    receivedData?.interviewDate.split(" ")[0].split("-")[1] +
                    "-" +
                    receivedData?.interviewDate.split(" ")[0].split("-")[0] ||
                    "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}
              >
                <Typography fontWeight={600}>Interview Type:</Typography>

                <Chip
                  size="small"
                  label={
                    receivedData?.inteviewType === "TECHNICAL"
                      ? receivedData?.inteviewType.charAt(0).toUpperCase() +
                        receivedData?.inteviewType.slice(1).toLowerCase()
                      : receivedData?.inteviewType || "N/A"
                  }
                  sx={{
                    fontWeight: 600,
                    borderRadius: "8px",
                    backgroundColor:
                      receivedData?.inteviewType === "TECHNICAL"
                        ? "#EEF5FF"
                        : "#F3F4F6",
                    color:
                      receivedData?.inteviewType === "TECHNICAL"
                        ? "#286A94"
                        : "#374151",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography fontWeight={600}>Interview Time:</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    px: 1,
                    borderRadius: "6px",
                  }}
                >
                  {receivedData?.interviewDate.split(" ")[1] || "N/A"}
                  {receivedData?.timeZone
                    ? ` ${receivedData?.timeZone.split(" ")[0]}`
                    : ""}
                </Typography>
              </Box>

              {receivedData?.candidateInterviewStatus !== null &&
                candidateIdData === "null" && (
                  <p className="">
                    Interview Status:{" "}
                    <span className="text-secondary fw-normal">
                      {/* SELECT, REJECT, ONHOLD, PENDING, NEXT_ROUND */}
                      {(receivedData?.candidateInterviewStatus === "SELECT"
                        ? "Selected"
                        : receivedData?.candidateInterviewStatus === "REJECT"
                        ? "Rejected"
                        : receivedData?.candidateInterviewStatus === "ONHOLD"
                        ? "On Hold"
                        : receivedData?.candidateInterviewStatus === "PENDING"
                        ? "Pending"
                        : receivedData?.candidateInterviewStatus ===
                          "NEXT_ROUND"
                        ? "Next Round"
                        : receivedData?.candidateInterviewStatus) ||
                        receivedData?.candidateInterviewStatus}
                    </span>{" "}
                  </p>
                )}
              {receivedData?.rating !== null && candidateIdData === "null" && (
                <p className="">
                  Score:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.rating || "N/A"}
                  </span>{" "}
                </p>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mt: 2,
                  mb: 2,
                }}
              >
                <Typography fontWeight={600}>Interview Status:</Typography>

                <Chip
                  size="small"
                  label={receivedData?.interviewStatus}
                  sx={{
                    fontWeight: 600,
                    borderRadius: "8px",
                    backgroundColor:
                      receivedData?.interviewStatus === "COMPLETED"
                        ? "#DCFCE7"
                        : receivedData?.interviewStatus === "CANCELLED"
                        ? "#FEE2E2"
                        : receivedData?.interviewStatus === "SCHEDULED"
                        ? "#E0F2FE"
                        : "#F3F4F6",
                    color:
                      receivedData?.interviewStatus === "COMPLETED"
                        ? "#166534"
                        : receivedData?.interviewStatus === "CANCELLED"
                        ? "#991B1B"
                        : receivedData?.interviewStatus === "SCHEDULED"
                        ? "#075985"
                        : "#374151",
                  }}
                />
              </Box>

              {/* {!location.pathname.includes(
                "/admin/interview/interviews_info"
              ) &&
                receivedData?.interviewStatus === "SCHEDULED" &&
                isJoinButtonEnabled() && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography fontWeight={600}>Interview Link:</Typography>

                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<VideoCallOutlined />}
                      href={receivedData?.interviewLink}
                      target="_blank"
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: "8px",
                      }}
                    >
                      Join Interview
                    </Button>
                  </Box>
                )} */}

              {!location.pathname.includes(
                "/admin/interview/interviews_info"
              ) &&
                receivedData?.resumeFileUrl && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <Typography fontWeight={600}>Resume:</Typography>

                    <Tooltip title="View Resume">
                      <Button
                        // className="btn-primary-custom"
                        size="small"
                        variant="outlined"
                        onClick={handleOpenResume}
                        sx={{
                          textTransform: "none",
                          minWidth: "auto",
                          px: 1,
                        }}
                      >
                        View Resume
                      </Button>
                    </Tooltip>
                  </Box>
                )}

              {receivedData?.remark &&
                (!candidateIdData ||
                  userIdData == receivedData?.interviewerId) && (
                  <Box
                    sx={{
                      p: 1.5,
                      borderRadius: "10px",
                      backgroundColor: "#F8FAFC",
                      border: "1px solid #E2E8F0",
                      display: "grid",
                      gap: 0.5,
                    }}
                  >
                    <Typography fontWeight={600}>Feedback</Typography>
                    <Typography
                      sx={{
                        color: "#6B7280",
                        fontWeight: 500,
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {receivedData?.remark}
                    </Typography>
                  </Box>
                )}

              {receivedData?.rating &&
                (!candidateIdData ||
                  userIdData == receivedData?.interviewerId) && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Typography fontWeight={600}>Score:</Typography>

                    <Chip
                      label={receivedData?.rating}
                      size="small"
                      sx={{
                        fontWeight: 700,
                        borderRadius: "8px",
                        backgroundColor: "#EEF5FF",
                        color: "#286A94",
                      }}
                    />
                  </Box>
                )}

              {!location.pathname.includes(
                "/admin/interview/interviews_info"
              ) &&
                receivedData?.jobAttachmentFile && (
                  <Box>
                    <Button
                      variant="outlined"
                      startIcon={<DescriptionOutlined />}
                      href={receivedData?.jobAttachmentFile}
                      target="_blank"
                      sx={{
                        width: "170px",
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: "10px",
                      }}
                    >
                      View Assignment
                    </Button>
                  </Box>
                )}

              {/* <p>
                Vendor Name:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.vendorName || "N/A"}
                </span>
              </p> */}

              {/* Feedback and Join Buttons */}
              {receivedData?.candidateInterviewStatus !== "PENDING" &&
                !candidateIdData && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Typography fontWeight={600}>
                      Interviewer Feedback:
                    </Typography>

                    <Chip
                      label={receivedData?.candidateInterviewStatus || "N/A"}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        px: 1.5,
                        borderRadius: "8px",
                        backgroundColor:
                          receivedData?.candidateInterviewStatus === "SELECT"
                            ? "#DCFCE7"
                            : receivedData?.candidateInterviewStatus ===
                              "REJECT"
                            ? "#FEE2E2"
                            : receivedData?.candidateInterviewStatus ===
                              "PENDING"
                            ? "#FEF3C7"
                            : "#FFEDD5", // fallback (ONHOLD / others)
                        color:
                          receivedData?.candidateInterviewStatus === "SELECT"
                            ? "#166534"
                            : receivedData?.candidateInterviewStatus ===
                              "REJECT"
                            ? "#991B1B"
                            : receivedData?.candidateInterviewStatus ===
                              "PENDING"
                            ? "#92400E"
                            : "#9A3412",
                      }}
                    />
                  </Box>
                )}

              <>
                {receivedData?.interviewStatus !== "CANCELLED" &&
                  userIdData == receivedData?.interviewerId && (
                    <div>
                      {receivedData?.isInterviewClosed ? (
                        <Feedback
                          recieve={receivedData}
                          reload={reload}
                          interviewId={receivedData?.interviewId}
                          feedData={receivedData?.remark}
                          setReload={setReload}
                          disable={!isFeedbackButtonEnabled()}
                        />
                      ) : (
                        <Button
                          className="btn-primary-custom"
                          style={{ width: "fit-content" }}
                          disabled={!isFeedbackButtonEnabled()}
                          onClick={() => setIsComplete(true)}
                        >
                          End Interview
                        </Button>
                      )}
                    </div>
                  )}

                {!location.pathname.includes("admin") &&
                  !receivedData?.isInterviewClosed &&
                  receivedData?.interviewStatus !== "COMPLETED" &&
                  receivedData?.interviewStatus !== "CANCELLED" && (
                    <div>
                      <Button
                        className="btn-primary-custom"
                        style={{ width: "fit-content" }}
                        disabled={
                          !isJoinButtonEnabled() ||
                          location.pathname.includes("admin")
                        }
                        href={receivedData?.interviewLink}
                        target="_blank"
                      >
                        <span style={{ color: "white" }}>Join Interview</span>
                      </Button>
                    </div>
                  )}
              </>
            </div>

            {!location.pathname.includes("admin") &&
              receivedData?.interviewStatus !== "COMPLETED" &&
              receivedData?.interviewStatus !== "CANCELLED" && (
                <div
                  style={{
                    padding: 10,
                    color: "rgb(234 179 8)",
                    fontSize: "15px",
                  }}
                >
                  {" "}
                  <i>
                    {" "}
                    Note :- <span> &nbsp; </span>{" "}
                    <span>
                      The Join button will be enabled 10 minutes before the
                      interview time
                    </span>
                    {userIdData == receivedData?.interviewerId && (
                      <span>
                        {" "}
                        & Feedback button will be enabled after 5 minutes of
                        interview time
                      </span>
                    )}
                  </i>
                </div>
              )}
          </div>
        </div>
        {location.pathname === "/admin/interview/interviews_info" && (
          <div>
            {
              <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <p className="common_table_header" style={{ margin: "0px" }}>
                    Resource Hiring Details
                  </p>
                  <div className="line_divide"></div>
                  {Object.keys(interviewerVendor ?? {})?.length > 0 ? (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            height: "12rem",
                            width: "12rem",
                            borderRadius: 10,
                            padding: 3,
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: 10,
                            }}
                            src={
                              interviewerVendor?.vendorProfileImageUrl ??
                              "https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png"
                            }
                            alt=""
                          />
                        </div>

                        <table style={{ flex: 1 }}>
                          <tbody
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                width > 500
                                  ? "repeat(auto-fit, minmax(350px, 1fr))"
                                  : "repeat(auto-fit, minmax(250px, 1fr))",
                              gap: 10,
                              wordBreak: "break-word",
                            }}
                          >
                            {[
                              {
                                label: "Vendor Id",
                                value: interviewerVendor?.vendorEmpId,
                              },
                              {
                                label: "Vendor Name",
                                value: `${
                                  interviewerVendor?.firstName ?? "N/A"
                                } ${interviewerVendor?.lastName ?? ""}`,
                              },
                              {
                                label: "Phone",
                                value: `+${interviewerVendor?.dialCode} ${
                                  interviewerVendor?.mobile ?? "N/A"
                                }`,
                              },
                              {
                                label: "Email",
                                value: interviewerVendor?.email ?? "N/A",
                              },
                              {
                                label: "Company Name",
                                value: interviewerVendor?.company ?? "N/A",
                              },
                              {
                                label: "Company Website",
                                value: interviewerVendor?.companyWebsite ? (
                                  <a
                                    href={interviewerVendor?.companyWebsite}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {interviewerVendor?.companyWebsite}
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                              {
                                label: "Location",
                                value:
                                  interviewerVendor?.address ||
                                  interviewerVendor?.city ||
                                  interviewerVendor?.country
                                    ? `${interviewerVendor?.address || ""} ${
                                        interviewerVendor?.city || ""
                                      } ${interviewerVendor?.country || ""}`
                                        .trim()
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(" ")
                                    : "N/A",
                              },
                              {
                                label: "Company Logo",
                                value: interviewerVendor?.companyLogoUrl ? (
                                  <a
                                    href={interviewerVendor?.companyLogoUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Link
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                            ].map((item, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: 6,
                                }}
                              >
                                <th
                                  style={{
                                    width: "35%",
                                    fontWeight: 500,
                                    color: "rgba(1, 41, 112, 0.6)",
                                    fontSize: width > 500 ? "15px" : "12px",
                                  }}
                                >
                                  {item.label}
                                </th>
                                <td
                                  style={{
                                    fontWeight: 300,
                                    fontSize: width > 500 ? "15px" : "12px",
                                  }}
                                >
                                  {item.value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      This Candidate have no Resource Provider , It's a
                      Individual Candidates
                    </div>
                  )}
                </div>
              </div>
            }

            {candidateVendor && (
              <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <p className="common_table_header" style={{ margin: "0px" }}>
                    Resource Provider Details
                  </p>
                  <div className="line_divide"></div>
                  {Object.keys(candidateVendor ?? {})?.length > 0 ? (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            height: "12rem",
                            width: "12rem",
                            borderRadius: 10,
                            padding: 3,
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: 10,
                            }}
                            src={
                              candidateVendor?.vendorProfileImageUrl ??
                              "https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png"
                            }
                            alt=""
                          />
                        </div>

                        <table style={{ flex: 1 }}>
                          <tbody
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                width > 500
                                  ? "repeat(auto-fit, minmax(350px, 1fr))"
                                  : "repeat(auto-fit, minmax(250px, 1fr))",
                              gap: 10,
                              wordBreak: "break-word",
                            }}
                          >
                            {[
                              {
                                label: "Vendor Id",
                                value: candidateVendor?.vendorEmpId,
                              },
                              {
                                label: "Vendor Name",
                                value: `${
                                  candidateVendor?.firstName ?? "N/A"
                                } ${candidateVendor?.lastName ?? ""}`,
                              },
                              {
                                label: "Phone",
                                value: `+${candidateVendor?.dialCode} ${
                                  candidateVendor?.mobile ?? "N/A"
                                }`,
                              },
                              {
                                label: "Email",
                                value: candidateVendor?.email ?? "N/A",
                              },
                              {
                                label: "Company Name",
                                value: candidateVendor?.company ?? "N/A",
                              },
                              {
                                label: "Company Website",
                                value: candidateVendor?.companyWebsite ? (
                                  <a
                                    href={candidateVendor?.companyWebsite}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {candidateVendor?.companyWebsite}
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                              {
                                label: "Location",
                                value:
                                  candidateVendor?.address ||
                                  candidateVendor?.city ||
                                  candidateVendor?.country
                                    ? `${candidateVendor?.address || ""} ${
                                        candidateVendor?.city || ""
                                      } ${candidateVendor?.country || ""}`
                                        .trim()
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(" ")
                                    : "N/A",
                              },
                              {
                                label: "Company Logo",
                                value: candidateVendor?.companyLogoUrl ? (
                                  <a
                                    href={candidateVendor?.companyLogoUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Link
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                            ].map((item, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: 6,
                                }}
                              >
                                <th
                                  style={{
                                    width: "35%",
                                    fontWeight: 500,
                                    color: "rgba(1, 41, 112, 0.6)",
                                    fontSize: width > 500 ? "15px" : "12px",
                                  }}
                                >
                                  {item.label}
                                </th>
                                <td
                                  style={{
                                    fontWeight: 300,
                                    fontSize: width > 500 ? "15px" : "12px",
                                  }}
                                >
                                  {item.value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      This Candidate have no Resource Provider , It's a
                      Individual Candidates
                    </div>
                  )}
                </div>
              </div>
            )}

            {!candidateVendor && (
              <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <div
                    style={{
                      paddingRight: 20,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "white",
                    }}
                  >
                    <div className="common_table_header">
                      {" "}
                      Candidate Details{" "}
                    </div>
                  </div>
                  <div className="line_divide"></div>
                  <div style={{ padding: 20, backgroundColor: "white" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "30px",
                        flexWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          height: "12rem",
                          width: "12rem",
                          borderRadius: 10,
                          padding: 3,
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            borderRadius: 10,
                          }}
                          src={
                            candidateDetails?.profileImageUrl ??
                            "https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png"
                          }
                          alt=""
                        />
                      </div>

                      <table style={{ flex: 1 }}>
                        <tbody
                          style={{
                            display: "grid",
                            width: "100%",
                            gridTemplateColumns:
                              width > 500
                                ? "repeat(auto-fit, minmax(350px, 1fr))"
                                : "repeat(auto-fit, minmax(250px, 1fr))",
                            gap: 10,
                            wordBreak: "break-word",
                          }}
                        >
                          {[
                            {
                              label: "Employee Id",
                              value: candidateDetails?.candidateEmpId,
                            },
                            {
                              label: "Full Name",
                              value: `${candidateDetails?.firstName} ${candidateDetails?.lastName}`,
                            },
                            {
                              label: "Phone",
                              value: `+${candidateDetails?.countryCode} ${candidateDetails?.mobile}`,
                            },
                            {
                              label: "Experience",
                              value: candidateDetails?.keyExperience,
                            },
                            {
                              label: "Designation",
                              value: candidateDetails?.currentDesignation,
                            },
                            { label: "Email", value: candidateDetails?.email },
                            {
                              label: "PAN NO.",
                              value: candidateDetails?.panCardNumber,
                            },
                            {
                              label: "AADHAAR NO.",
                              value: candidateDetails?.aadharCardNumber,
                            },
                            {
                              label: "Department",
                              value:
                                candidateDetails?.department?.replace(
                                  /_/g,
                                  " "
                                ) || "N/A",
                            },
                            {
                              label: "Skills",
                              value:
                                candidateDetails?.skillList?.join(", ") ||
                                "N/A",
                            },
                          ].map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 6,
                              }}
                            >
                              <th
                                style={{
                                  fontWeight: 500,
                                  color: "rgba(1, 41, 112, 0.6)",
                                  width: "35%",
                                  wordBreak: "break-word",
                                  fontSize: width > 500 ? "15px" : "12px",
                                }}
                              >
                                {item.label}
                              </th>
                              <td
                                style={{
                                  fontWeight: 300,
                                  wordBreak: "break-word",
                                  fontSize: width > 500 ? "15px" : "12px",
                                }}
                              >
                                {item.value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Dialog
        open={openResume}
        onClose={handleCloseResume}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Resume Preview
          <IconButton onClick={handleCloseResume}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0, height: "80vh" }}>
          <iframe
            src={receivedData?.resumeFileUrl}
            title="Resume"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </DialogContent>
      </Dialog>

      <Modal
        show={isInterviewComplete}
        onHide={() => setIsComplete(false)}
        backdrop="static"
        keyboard={false}
        style={{ top: "25%" }}
      >
        <Modal.Header>
          <Modal.Title className="w-100 text-center">
            Over Interview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center fs-5">
          Are you sure this interview is over?
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            disabled={isComeDis}
            className="btn-lg btn-primary-custom"
            onClick={handleCompleteInterview}
          >
            {isComeDis ? "Loading..." : "Yes"}
          </button>
          <Button
            variant="secondary"
            className="btn-lg"
            onClick={() => setIsComplete(false)}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AssignedInterviewsInfo;
